import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function customEmailValidator(): ValidatorFn {
  // Regex excludes apostrophe (') in local part
  //const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  const emailRegex = /^[a-zA-Z0-9._%+'-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

  return (control: AbstractControl): ValidationErrors | null => {
    const email = control.value;
    if (!email) return null; // don't validate empty fields

    // Reject if contains any invalid character like space
    if (/[\s]/.test(email)) {
      return { email: true };
    }

    // Quick length checks
    if (email.length > 320) return { email: true };

    const parts = email.split('@');
    if (parts.length !== 2) return { email: true };

    const [username, domain] = parts;

    if (!username || username.length > 64 || username.length < 1) return { email: true };
    if (!domain || domain.length > 255 || domain.length < 1) return { email: true };

    // Username rules
    if (/^[-.]|[-.]$|\.\./.test(username)) return { email: true };

    // Domain rules
    if (!domain.includes('.')) return { email: true };
    const domainLabels = domain.split('.');
    for (const label of domainLabels) {
      if (
        !label ||
        label.length > 63 ||
        /^-/.test(label) ||
        /-$/.test(label) ||
        /[^a-zA-Z0-9-]/.test(label)
      ) {
        return { email: true };
      }
    }

    // Final pattern validation
    if (!emailRegex.test(email)) return { email: true };

    return null; // ✅ valid email
  };
}
